module.exports = __webpack_public_path__ + "img/banner.14a01eb6.jpg";